export const LIQUID_TAGS = [
  'assign',
  'capture',
  'capture',
  'case',
  'case',
  'check_attachments',
  'comment',
  'cycle',
  'disabletracking',
  'disable_tracking',
  'discard',
  'else',
  'elsif',
  'endcapture',
  'endcase',
  'endcomment',
  'endfor',
  'endif',
  'endinclude',
  'endmarker',
  'endraw',
  'endtablerow',
  'endunless',
  'for',
  'for',
  'forloop',
  'if',
  'if',
  'image',
  'in',
  'include',
  'load_ad',
  'load_adtag',
  'load_adtags',
  'load_plugin',
  'marker',
  'marker',
  'modify_subject',
  'modifysubject',
  'plugin',
  'raw',
  'reject',
  'remove_trackers',
  'removetrackers',
  'reversed',
  'set_header',
  'style',
  'tablerow',
  'tablerow',
  'tablerowloop',
  'text',
  'unless',
  'unless',
  'warn',
  'when',
  'widget'
];

export const LIQUID_CLOSING_TAGS = ['capture', 'case', 'comment', 'for', 'if', 'tablerow', 'unless'];

export const LIQUID_BRACES_UNCLOSED_REGEXP = /({{(?![^{]*}}))|({%(?![^{]*%}))/g;
export const LIQUID_TAGS_BROKEN_REGEXP = /{%\s*(\w+)/g;
export const LIQUID_TAGS_REGEXP = /{%(?:.*?)(\w+)(?:.*?)%}$/;
